import React from 'react';
import icon from 'assets/ppsc_images/PlungerLift.png';

const Icon = ({ width }) => <img src={icon} alt="PlungerLift" width={width || '25'} />;

export default Icon;
